import { makeAutoObservable } from 'mobx';
import { LimitsApiResponse } from '../../api/GroupApi';

export class Limits {
  isLimited: boolean = false;
  isRuleLimited: boolean = false;
  allowance: number = 0;
  used: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: LimitsApiResponse): Limits {
    const limits = new Limits();

    limits.isLimited = apiData.limited;
    limits.isRuleLimited = apiData.rulesLimited;
    limits.allowance = apiData.totalMonthlyAllowance + apiData.totalCarriedOverAllowance;
    limits.used = apiData.usedMonthlyAllowance;

    return limits;
  }

  get remaining(): number {
    return this.allowance - this.used;
  }
}
